import BatchPageContent from '@/components/BatchPage'

export default function BatchPage() {
  return <BatchPageContent />
}

